import { QueryModelCore } from "@/core/model.core";
import Browser from "@/core/browser";
import { getWXOpenid } from "@/core/authUtil";

export default class Order {
  /**
   * 确认订单
   * @param {Object} params {
   *    @param {string} skuNo
   *    @param {string} goTime 选择的日期
   *    @param {number} goodsNum 购买数量(不区分出行人)
   *    @param {Array} personList 购买数量(区分出行人) {
   *        @param {string} personType 出行人类别
   *        @param {number} goodsNum 购买数量
   *    }
   * }
   */
  async comfirmOrder(params) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/getConfirmTrade' : '/api-trade/tradeApplet/getConfirmTrade';
    const confirmParams = { ...params };
    const result = await new QueryModelCore(url).post(confirmParams);
    const { dataMap } = result;
    return dataMap;
  }

  async checkTrade(params) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/getConfirmTrade' : '/api-trade/tradeApplet/checkTrade';
    const confirmParams = { ...params };
    const result = await new QueryModelCore(url).post(confirmParams);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 校验订单金额
   * @param {Object} params {
   *    @param {string} skuNo
   *    @param {string} goTime 选择的日期
   *    @param {number} goodsNum 购买数量(不区分出行人)
   *    @param {Array} personList 购买数量(区分出行人) {
   *        @param {string} personType 出行人类别
   *        @param {number} goodsNum 购买数量
   *    }
   *    @param {string} roomCount 房差数量
   *    @param {string} couponId 优惠券id[H5项目暂时没有]
   *    @param {string} attachList 附加费用 {
   *        @param {number} id
   *        @param {number} serviceNum 购买数量
   *    }
   * }
   */
  async checkOrderAmout(params) {
    const result = await new QueryModelCore('/api-trade/tradeApplet/checkTradeAmount').post({
      ...params,
      channel: Browser.ysfMiniprogram ? 2 : 1
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 提交订单
   * @param {Object} params 订单参数
   */
  async submitOrder(params) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/addYSFTrade' : '/api-trade/tradeApplet/addTrade';
    let paramsNew = { ...params };
    if (!Browser.ysfMiniprogram) {
      paramsNew.tradeChannel = 5;
    }
    const result = await new QueryModelCore(url).post(paramsNew);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 根据订单编号获取支付信息
   * @param {string} tradeCode 订单编号
   */
  async getPayInfo(tradeCode) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/getTnByTradeCode' : '/api-trade/payment/wxPay';
    const params = { tradeCode };
    if (Browser.weiXin) {
      params.openIdH5 = getWXOpenid();
    }
    const result = await new QueryModelCore(url).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 取消订单
   * @param {string} tradeCode 订单编号
   */
  async cancelOrder(tradeCode) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/cancelTrade' : '/api-trade/tradeApplet/cancelTrade';
    const result = await new QueryModelCore(url).post({ tradeCode });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取订单列表(分页)
   * @param {Object} params {
   *    @param {number} current
   *    @param {number} size
   *    @param {number} tradeType 订单类型 10-出行订单 30-票券订单 40-酒店订单 50-商品订单
   *    @param {number} tradeStatus 订单状态 10-待付款 20-已付款 30-待发货 31-待出行 40-待收货 60-交易完成 80-售后中 90-已取消
   * }
   */
  async orderPagingList(params) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/getMyTrade' : '/api-trade/tradeApplet/getMyTrade';
    const result = await new QueryModelCore(url).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取订单详情
   * @param {Object} params {
   *    @param {string} tradeCode 订单编号(查订单详情时传入)
   *    @param {string} refundCode 退单编号(查退单详情时传入)
   * }
   */
  async orderDetail(params) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/getMyTradeDetail' : '/api-trade/tradeApplet/getMyTradeDetail';
    const result = await new QueryModelCore(url).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 申请退款
   * @param {string} tradeCode 订单编号
   * @param {number} type 退款类型(默认1)
   * @param {number} tradeChannel 订单来源(云闪付默认3)
   * @param {string} returnReason 退款原因
   */
  async refundOrder({ tradeCode, type = 1, returnReason }) {
    const result = await new QueryModelCore('/api-trade/tradeRefund/addRefund').post({
      tradeCode, type, returnReason,
      tradeChannel: Browser.ysfMiniprogram ? 3 : 5
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 取消退单
   * @param {string} refundCode 退单编号
   */
  async cancelRefundOrder(refundCode) {
    const url = Browser.ysfMiniprogram ? '/api-trade/tradeYSF/cancelTradeRefund' : '/api-trade/tradeApplet/cancelTradeRefund';
    const result = await new QueryModelCore(url).post({ refundCode });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取商品sku全部可售卖月份
   */
    async getSkuStockPriceMonthList(params) {
      const result = await new QueryModelCore(
        '/api-prod/app/getSkuStockPriceMonthList'
      ).get(params);
      const { dataMap } = result;
      return dataMap;
    }
  
  /**
   * 计算订单金额(新)
   */
    async checkTradeAmountNew(params) {
    const result = await new QueryModelCore(
      '/api-trade/tradeApplet/checkTradeAmountNew'
    ).post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 申请发票
   */
  async applyBill(params) {
    const result = await new QueryModelCore(
      '/api-trade/tradeApplet/applyBill'
    ).post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 申请发票
   */
  async getBillCate(params) {
    const result = await new QueryModelCore(
      '/api-trade/tradeApplet/getBillCate'
    ).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  async getPhonePrefix(params) {
    const result = await new QueryModelCore(
      '/api-tmc/app/baseInfo/getPhonePrefix'
    ).get(params);
    const { dataMap } = result;
    return dataMap;
  }
}